export enum RoutePlanningActions {
  'NONE' = 'NONE',
  'CREATE_BASE' = 'CREATE_BASE',
  'DRAW_ROUTE' = 'DRAW_ROUTE',
  'EDIT_ROUTE' = 'EDIT_ROUTE',
}

export interface LeafletDrawEvent {
  layer: L.Layer;
  layerType: string;
  sourceTarget: any;
  target: any;
  type: string;
}

export interface CreateBasePayload {
  project_id: number;
  lat: number;
  lng: number;
  notes?: string;
  identifier?: string;
}

export interface CreateRoutePayload {
  project_id: number;
  coordinates: { lat: number, lng: number }[];
  color: string;
  notes?: string;
  identifier?: string;
}

export interface UpdateRoutePayload {
  project_id: number;
  route_id: number;
  color?: string;
  notes?: string;
  identifier?: string;
}

export interface UpdateBasePayload {
  project_id: number;
  base_id: number;
  notes?: string;
  identifier?: string;
}

export interface RemoveBasePayload {
  project_id: number;
  base_id: number;
}

export interface RemoveRoutePayload {
  project_id: number;
  route_id: number;
}

export interface CreateBaseReportPayload {
  base_id: number | string,
  status_id: number | string,
  workerteam_id: number | string | null,
  report_type?: number | string,
  notes?: string,
  identifier?: string,
  interrupt_code?: number | string,
  images?: string;
  name: string;
}

export interface RoutePlanningBase {
  id: number;
  project_id?: number;
  coordinates: { lat: number, lng: number };
  notes?: string;
  identifier?: string;
}

export interface RoutePlanningRoute {
  id: number;
  identifier?: string;
  project_id?: number;
  coordinates: { lat: number, lng: number }[];
  notes?: string;
  color: string;
}

export interface BaseReport {
  name: string;
  id: number;
  base_id: number;
  status_id: number;
  report_type?: number;
  notes?: string;
  identifier?: string;
  interrupt_code?: number;
  attend_time?: string;
  attendee?: number;
  workerteam_id?: number;
  created?: string;
  attendee_name?: string;
  images?: {
    id?: number;
    title?: string;
    url?: string;
  }[];
}

export const ROUTE_PLANNER_POLYLINE_COLOR = '#72ff16';
export const ROUTE_PLANNER_POLYLINE_EDIT_COLOR = 'red';
export const ROUTE_PLANNER_POLYLINE_HIGHLIGHT_COLOR = '#e8e8e8';

export const ROUTE_PLANNER_POLYLINE_SHAPE_OPTIONS = {
  color: ROUTE_PLANNER_POLYLINE_COLOR,
  originalColor: ROUTE_PLANNER_POLYLINE_COLOR,
  weight: 4,
  opacity: 1,
  fillOpacity: 1,
  dashArray: '10, 10',
}

export const ROUTE_PLANNER_POLYLINE_SHAPE_EDIT_OPTIONS = {
  maintainColor: false,
  color: ROUTE_PLANNER_POLYLINE_EDIT_COLOR,
  opacity: 0.7,
  fillOpacity: 0.7
}

export const ROUTE_PLANNER_DRAW_OPTIONS = {
  position: 'topright',
  draw: {
    polygon: false,
    polyline: false,
    circle: false,
    rectangle: false,
    marker: false,
    circlemarker: false
  },
  edit: {
    remove: false,
    edit: false
  }
};

export interface RouteNote {
  id: number;
  route_id: number;
  coordinates: { lat: number, lng: number };
  notes: string;
}

export interface RouteNotePayload {
  project_id: number;
  route_id: number;
  coordinates: { lat: number, lng: number };
  notes: string;
}

export interface RouteNoteUpdatePayload {
  project_id: number;
  route_note_id: number;
  notes: string;
}

export interface RouteNoteRemovePayload {
  project_id: number;
  route_note_id: number;
}
